import React from 'react'
import PropTypes from 'prop-types'
import FICColors from '../../general/js/FICColors'
import styled from 'styled-components'

import '../css/FAIcon.css'

function FAIconF (props) {
  let { name, className, spin, color, size, fixedWidth, ...iconProps } = props
  let prefix = 'fa'
  let icon = name

  if (Array.isArray(name)) {
    if (name.length === 1) {
      icon = name[0]
    } else if (name.length > 1) {
      prefix = name[0]
      icon = name[1]
    }
  }

  className = prefix + ' faicon fa-' + icon + ' ' + className
  if (spin) { className += ' fa-spin' }
  if (fixedWidth) { className += ' fa-fw' }
  return <b className={className} {...iconProps} />
}

const FAIcon = styled(FAIconF)`
  color: ${props => FICColors[props.color] || props.color || undefined};
  font-size: ${props => props.size ? (props.size + 'px') : undefined};
`

FAIcon.propTypes = FAIconF.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
  style: PropTypes.object,
  spin: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number,
  fixedWidth: PropTypes.bool
}

FAIconF.defaultProps = {
  name: undefined,
  className: '',
  style: {},
  spin: false,
  color: undefined,
  size: undefined,
  fixedWidth: false
}

export const FALIcon = ({ name, ...props }) => <FAIcon name={['fal', name]} {...props} />

export default FAIcon



// WEBPACK FOOTER //
// ./src/common/components/js/FAIcon.js